// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"510":"d4931a99","791":"6e8b4d1e","2384":"722ec41d","4205":"149264fd","7443":"e368e050","8348":"3b53517f","9233":"0c815040"}[chunkId] + ".chunk.css";
};